import React from 'react'
import WbModal from '../../common/WbModal'
import WbButton from '../../common/WbButton'
import WbOutlineButton from '../../common/WbOutlineButton'
import {Grid, Typography} from '@mui/material'
import {getAppUrls} from '../../../utils/Config'
import {useNavigate} from 'react-router-dom'
import paths from '../../../routes/paths'

export default function EmojiQrWarning({hide, setHide}) {
  const navigate = useNavigate()
  return (
    !hide && (
      <WbModal
        onClose={() => setHide(true)}
        content={
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Typography variant="h6">
                Survey published successfully
              </Typography>
            </Grid>
            <Grid item xs={12}>
              Gnerate and download your QR codes for each student in your data
              management setting.
            </Grid>
            <Grid item xs={12} style={{textAlign: 'right'}}>
              <WbOutlineButton
                onClick={() => {
                  setHide(false)
                  navigate(paths.dashboard)
                }}
                CustomOutlineButtonText={"I'll do it later"}
              >
                Generate QR
              </WbOutlineButton>{' '}
              <WbButton
                onClick={() => {
                  
                  setHide(false)
                  navigate(paths.dashboard)
                  window.location.href = getAppUrls().PPL_MNGMT_URL
                }}
                CustomButtonText={'Generate codes'}
              ></WbButton>
            </Grid>
          </Grid>
        }
      />
    )
  )
}
